import type { QueryClient } from "@tanstack/react-query";
import {
  financialOverviewQueryKey,
  financialQueryKeys,
} from "./financialQueryKeys";

/** Refreshes the current-month list and the overview after a transaction changes. */
export const invalidateFinancialListQueries = (
  qc: QueryClient,
  flow: "income" | "outcome",
  terreiroId?: string,
  mediumId?: string,
) =>
  Promise.all([
    qc.invalidateQueries({
      queryKey:
        flow === "income"
          ? financialQueryKeys.currentMonthIncome(terreiroId, mediumId)
          : financialQueryKeys.currentMonthOutcome(terreiroId, mediumId),
    }),
    terreiroId
      ? qc.invalidateQueries({ queryKey: financialOverviewQueryKey({ terreiroId }) })
      : undefined,
    mediumId
      ? qc.invalidateQueries({ queryKey: financialOverviewQueryKey({ mediumId }) })
      : undefined,
  ]);
